export type TimeStampOutput = {
  window_end: string;
  window_start: string;
};

export const convertAppointmentFormat = (appointment: {
  date: string;
  endTime?: string;
  startTime: string;
}): TimeStampOutput => {
  const convertTimeToBookingFormat = (date: string, time: string) => {
    const [year, month, day] = date.split('/').map(Number);

    const timeComponents = time.match(/(\d+)(am|pm)?/i);
    let hour = timeComponents ? parseInt(timeComponents[1], 10) : 0;
    const period = timeComponents ? timeComponents[2] : '';

    if (period?.toLowerCase() === 'pm' && hour < 12) {
      hour += 12;
    } else if (period?.toLowerCase() === 'am' && hour === 12) {
      hour = 0;
    }

    const localDate = new Date(year, month - 1, day, hour);

    return localDate.toISOString().split('.')[0].replace('T', ' ');
  };

  const window_start = convertTimeToBookingFormat(
    appointment.date,
    appointment.startTime
  );
  const window_end = convertTimeToBookingFormat(
    appointment.date,
    appointment.endTime ? appointment.endTime : ''
  );

  return {
    window_end,
    window_start,
  };
};
